/**
 * CL-ACCESS-PROJECT-OPERATOR-001A — Capability-driven project tools in simple portal (pure).
 */

import { clientHasTradesSuppliersModuleAccess, collaboratorHasProjectSupplierManagementAccess } from "./clientPortalEffectiveAccessModel";
import {
  resolveAdminProjectSpecificationsAccess,
  shouldShowAdminSpecificationsTab,
} from "./projectSpecificationAccessModel";
import {
  isActiveCanonicalAssignment,
  resolveAdminProductsSelectionsAccess,
  shouldShowAdminProductsSelectionsTab,
} from "./adminProjectProductsSelectionsModel";
import {
  clientPortalDesignBoardsTabAllowed as designBoardsTabAllowed,
  resolveClientPortalDesignBoardsAccess,
} from "./projectDesignBoardPortalAccessModel";

function resolveActiveAssignmentForPortal(assignment = null, permissions = {}) {
  if (assignment && isActiveCanonicalAssignment(assignment)) {
    return assignment;
  }
  if (permissions && typeof permissions === "object" && Object.keys(permissions).length > 0) {
    return { status: "active", permissions };
  }
  return assignment;
}

export function clientPortalDesignBoardsTabAllowed(permissions = {}, assignment = null) {
  return designBoardsTabAllowed(permissions, resolveActiveAssignmentForPortal(assignment, permissions));
}

export { resolveClientPortalDesignBoardsAccess };

export function clientPortalSpecificationsTabAllowed(permissions = {}, assignment = null) {
  return shouldShowAdminSpecificationsTab(
    resolveAdminProjectSpecificationsAccess({
      permissions,
      assignment: resolveActiveAssignmentForPortal(assignment, permissions),
    })
  );
}

export function resolveClientPortalSpecificationsAccess({
  permissions = {},
  assignment = null,
  isGlobalAdmin = false,
} = {}) {
  return resolveAdminProjectSpecificationsAccess({
    isGlobalAdmin,
    assignment: resolveActiveAssignmentForPortal(assignment, permissions),
    permissions,
  });
}

export function clientPortalTradesSuppliersTabAllowed(permissions = {}) {
  return (
    clientHasTradesSuppliersModuleAccess(permissions)
    || collaboratorHasProjectSupplierManagementAccess(permissions)
  );
}

export const CLIENT_PORTAL_TRADES_SUPPLIERS_PANEL_MODE = Object.freeze({
  NONE: "none",
  OPERATIONAL: "operational",
  CLIENT_PRESENTATION: "client_presentation",
});

export function resolveClientPortalTradesSuppliersPanelMode(permissions = {}) {
  if (collaboratorHasProjectSupplierManagementAccess(permissions)) {
    return CLIENT_PORTAL_TRADES_SUPPLIERS_PANEL_MODE.OPERATIONAL;
  }
  if (clientHasTradesSuppliersModuleAccess(permissions)) {
    return CLIENT_PORTAL_TRADES_SUPPLIERS_PANEL_MODE.CLIENT_PRESENTATION;
  }
  return CLIENT_PORTAL_TRADES_SUPPLIERS_PANEL_MODE.NONE;
}

export function clientPortalProjectProductsSelectionsAllowed({
  permissions = {},
  assignment = null,
} = {}) {
  return shouldShowAdminProductsSelectionsTab(
    resolveAdminProductsSelectionsAccess({ assignment, permissions })
  );
}
